import axios from "axios";

export default class lostItems {
  constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;
  }
  async getLostItemsByStatus(params) {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/lostItem/?limit=${params.limit}&page=${
          params.page
        }&published=${params.published}&status=${params.status}`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async getLostItemsCategorys(language) {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/lostItem/category`,
        headers: {
          "accept-language": language
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async createItem(params) {
    try {
        console.log("Params enviados:", params);
        const response = await axios({ method: "post",
                                       url: `${this.API_LINK}/lostItem/`,
                                       data: params});
        console.log('Response: ',response);
      return response.data;
    } catch (error) {
      //throw error;
      console.log('Error:: ',error);
    }
  }
  async updateItem(id, params) {
    try {
      const response = await axios({
        method: "patch",
        url: `${this.API_LINK}/lostItem/${id}`,
        data: params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async getEmail() {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/bin/generals/LostItemRequest`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async saveEmail(link) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/bin/generals`,
        data: {
          name: "LostItemRequest",
          title: link,
          author: " ",
          body: link
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
  async getEmailSecurity() {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/bin/generals/LostItemSecurity`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async saveEmailSecurity(link) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/bin/generals`,
        data: {
          name: "LostItemSecurity",
          title: link,
          author: " ",
          body: link
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
}
